import React, { createContext, useCallback, useContext, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { artifacts } from '../../../api/integrations'

const ArtifactContext = createContext({
  selectedArtifactId: null,
  selectedArtifact: null,
  connectionId: undefined,
  isLoading: false,
  error: null,
  selectArtifact: () => {}
})

export const useArtifact = () => useContext(ArtifactContext)

function ArtifactProvider ({ children, connectionId }) {
  const [selectedArtifactId, setSelectedArtifactId] = useState(null)

  const { data, isLoading, error } = artifacts.useGetArtifactById(selectedArtifactId)

  const selectArtifact = useCallback((id) => {
    setSelectedArtifactId(id ?? null)
  }, [])

  const value = useMemo(() => ({
    selectedArtifactId,
    selectedArtifact: data?.artifact ?? null,
    connectionId,
    isLoading,
    error,
    selectArtifact
  }), [selectedArtifactId, data, connectionId, isLoading, error, selectArtifact])

  return (
    <ArtifactContext.Provider value={value}>
      {children}
    </ArtifactContext.Provider>
  )
}

ArtifactProvider.propTypes = {
  children: PropTypes.node,
  connectionId: PropTypes.number
}

export default ArtifactProvider
